// src/pages/ProfileWrapper.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Profile from './Profile';
import UserProfile from './UserProfile';

export default function ProfileWrapper({ API: propAPI, token: propToken }) {
  const API = propAPI || process.env.REACT_APP_API_URL || 'https://vartasocial.com';
  const token = propToken || localStorage.getItem('token') || '';

  const { handle } = useParams();
  const normHandle = (handle || '').toLowerCase();

  const [me, setMe] = useState(undefined); // undefined = loading, null = no user
  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!token) {
        if (mounted) setMe(null);
        return;
      }
      try {
        const { data } = await axios.get(`${API}/me`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
        if (!mounted) return;
        setMe(data?.user || null);
      } catch {
        if (!mounted) return;
        setMe(null);
      }
    })();
    return () => { mounted = false; };
  }, [API, token]);

  if (me === undefined) return <div className="page">Loading…</div>;

  // If logged in and visiting your own handle => mount Profile (owner view)
  if (me && me.user_id && String(me.user_id).toLowerCase() === normHandle) {
    // pass handle explicitly (Profile will fallback to useParams if prop missing)
    return <Profile API={API} token={token} handle={normHandle} />;
  }

  // Otherwise show public user profile (visitor view)
  return <UserProfile API={API} token={token} handle={normHandle} />;
}